import fileDownload from 'js-file-download';

import request from '@utils/request';
import { serialize } from '@utils/helpers';

import {
  hideLoadingModal,
  showLoadingModal,
} from '@actions/loadingModal';

const PREFIX = '[EXPORT]';

export const POST_DOCKETS_EXPORT_REQUEST = `${PREFIX} POST_DOCKETS_EXPORT_REQUEST`;
export const POST_DOCKETS_EXPORT_SUCCESS = `${PREFIX} POST_DOCKETS_EXPORT_SUCCESS`;
export const POST_DOCKETS_EXPORT_FAILURE = `${PREFIX} POST_DOCKETS_EXPORT_FAILURE`;

const postDocketsExportRequest = () => ({
  type: POST_DOCKETS_EXPORT_REQUEST,
});

const postDocketsExportSuccess = () => ({
  type: POST_DOCKETS_EXPORT_SUCCESS,
});

const postDocketsExportFailure = () => ({
  type: POST_DOCKETS_EXPORT_FAILURE,
});

export const downloadDocketsCSV = (caseId, docketsList) => (dispatch) => {
  dispatch(postDocketsExportRequest());
  showLoadingModal(dispatch);

  return request
    .post(`v1/cases/${caseId}/dockets/export/`, { export: docketsList })
    .then(({ data }) => {
      dispatch(postDocketsExportSuccess());

      if (data) fileDownload(data, `case-${caseId}-dockets.csv`);
    })
    .catch((error) => {
      dispatch(postDocketsExportFailure());

      throw error;
    })
    .finally(() => hideLoadingModal(dispatch));
};

export const GET_DOCKETS_EXPORT_REQUEST = `${PREFIX} GET_DOCKETS_EXPORT_REQUEST`;
export const GET_DOCKETS_EXPORT_SUCCESS = `${PREFIX} GET_DOCKETS_EXPORT_SUCCESS`;
export const GET_DOCKETS_EXPORT_FAILURE = `${PREFIX} GET_DOCKETS_EXPORT_FAILURE`;

const getDocketsExportRequest = () => ({
  type: GET_DOCKETS_EXPORT_REQUEST,
});

const getDocketsExportSuccess = () => ({
  type: GET_DOCKETS_EXPORT_SUCCESS,
});

const getDocketsExportFailure = () => ({
  type: GET_DOCKETS_EXPORT_FAILURE,
});

export const downloadAllDocketsCSV = (caseId, options) => (dispatch) => {
  const queryString = serialize(options);

  dispatch(getDocketsExportRequest());
  showLoadingModal(dispatch);

  return request
    .post(`v1/cases/${caseId}/dockets/export/?${queryString}`)
    .then(({ data }) => {
      dispatch(getDocketsExportSuccess());

      if (data) fileDownload(data, `case-${caseId}-dockets.csv`);
    })
    .catch((error) => {
      dispatch(getDocketsExportFailure());

      throw error;
    })
    .finally(() => hideLoadingModal(dispatch));
};

export const POST_CLAIMS_EXPORT_REQUEST = `${PREFIX} POST_CLAIMS_EXPORT_REQUEST`;
export const POST_CLAIMS_EXPORT_SUCCESS = `${PREFIX} POST_CLAIMS_EXPORT_SUCCESS`;
export const POST_CLAIMS_EXPORT_FAILURE = `${PREFIX} POST_CLAIMS_EXPORT_FAILURE`;

const postClaimsExportRequest = () => ({
  type: POST_CLAIMS_EXPORT_REQUEST,
});

const postClaimsExportSuccess = () => ({
  type: POST_CLAIMS_EXPORT_SUCCESS,
});

const postClaimsExportFailure = () => ({
  type: POST_CLAIMS_EXPORT_FAILURE,
});

export const downloadClaimsCSV = (caseId, claimsList) => (dispatch) => {
  dispatch(postClaimsExportRequest());
  showLoadingModal(dispatch);

  return request
    .post(`v1/cases/${caseId}/claims/export/`, { export: claimsList })
    .then(({ data }) => {
      dispatch(postClaimsExportSuccess());

      if (data) fileDownload(data, `case-${caseId}-claims.csv`);
    })
    .catch((error) => {
      dispatch(postClaimsExportFailure());

      throw error;
    })
    .finally(() => hideLoadingModal(dispatch));
};

export const GET_CLAIMS_EXPORT_REQUEST = `${PREFIX} GET_CLAIMS_EXPORT_REQUEST`;
export const GET_CLAIMS_EXPORT_SUCCESS = `${PREFIX} GET_CLAIMS_EXPORT_SUCCESS`;
export const GET_CLAIMS_EXPORT_FAILURE = `${PREFIX} GET_CLAIMS_EXPORT_FAILURE`;

const getClaimsExportRequest = () => ({
  type: GET_CLAIMS_EXPORT_REQUEST,
});

const getClaimsExportSuccess = () => ({
  type: GET_CLAIMS_EXPORT_SUCCESS,
});

const getClaimsExportFailure = () => ({
  type: GET_CLAIMS_EXPORT_FAILURE,
});

export const downloadAllClaimsCSV = (caseId, options = {}) => (dispatch) => {
  const queryString = serialize(options);

  dispatch(getClaimsExportRequest());
  showLoadingModal(dispatch);

  return request
    .get(`v1/cases/${caseId}/claims/export/?${queryString}`)
    .then(({ data }) => {
      dispatch(getClaimsExportSuccess());

      if (data) fileDownload(data, `case-${caseId}-claims.csv`);
    })
    .catch((error) => {
      dispatch(getClaimsExportFailure());

      throw error;
    })
    .finally(() => hideLoadingModal(dispatch));
};



// WEBPACK FOOTER //
// ./src/store/actions/export.js